module.exports = __webpack_public_path__ + "img/back-terre.60c39c02.jpg";